import { render, staticRenderFns } from "./form-submission-state-label.vue?vue&type=template&id=8037bd3e"
import script from "./form-submission-state-label.vue?vue&type=script&lang=js"
export * from "./form-submission-state-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports